//fonction pour  requeter l'API afin de récuperer la liste des installations en fonction des filtres
import { app_placeholder } from '../../../env.placeholders';
import { prepareBcLabelToRequest } from '../../helper';
import { HttpArcgis } from '../../http';
import { LocalStorage } from '../../localStorage';
import { defineDefinitionExpression } from '../map/defExpHelper';

// return codes of amont and aval points to show on the map
export const prepareCodeToShow = (pAllBc: any[], pAvalPoint: string) => {
  let codes: string = '';
  // get codes hence name of bc selected
  const getBc = pAllBc.filter((d) => d.avalPoint === pAvalPoint)[0];
  // create request
  codes += "'" + getBc.avalPoint + "'";
  if (Array.isArray(getBc.amontPoints)) {
    codes += ',';
    getBc.amontPoints.forEach((amontPoint: string, index: number) => {
      if (index !== getBc.amontPoints.length - 1) {
        codes += "'" + amontPoint + "',";
      } else {
        codes += "'" + amontPoint + "'";
      }
    });
  }
  return codes;
};

// method to feed table
export const getEcpBc = async (
  pFilters: any,
  pContractCode: string,
  pAddFilter: string,
) => {
  // prepare queries
  let data: any[] = [];
  const filterEnd = pAddFilter === 'no bc' ? '' : pAddFilter;
  let query: string =
    defineDefinitionExpression(pFilters, 'ecp', pContractCode) + filterEnd;

  // form for request sevice
  const formBody: string[] = [];
  formBody.push('where=' + query);
  formBody.push(
    'outFields=Code,Color,Description,RecordDate,Commune'
  );
  formBody.push('returnGeometry=true');
  formBody.push('f=json');
  formBody.push('user=' + LocalStorage.userMail.get());
  const formBodyToSend = formBody.join('&');

  try {
    // launch request
    const responseSections = await HttpArcgis.post(
      app_placeholder.VITE_APP_ARCGIS_SERVER + '?path=/52/query',
      JSON.stringify(formBodyToSend),
    );
    let datas: any[] = [];
    if (
      responseSections.status === 200 &&
      responseSections.data.features !== undefined
    ) {
      datas = responseSections.data.features;
      datas.forEach((feat) => {
        // get geometry for zoom
        feat['attributes'].geometry = feat['geometry'];
        data.push(feat['attributes']);
      });
    } else {
      console.log('Aucune données !');
    }
  } catch (error) {
    console.log('Failed to get data for table', error);
  }
  return data;
};

export const getDataEcp = async (
  pAllBc: any[],
  pAvalPoint: any,
  pContractCode: any,
  filters: object
) => {
  let filter;
  let getAvalPoints;

  // specific bc selected
  if (pAvalPoint !== '') {
    // get data of bc
    const getBc = pAllBc.filter((d) => d.avalPoint === pAvalPoint);
    if (getBc[0] && getBc[0].avalPoint !== null) {
      getAvalPoints = prepareBcLabelToRequest(getBc);
      if (getAvalPoints !== '') {
        filter = 'AND Code in(' + getAvalPoints + ')';
      } else {
        filter = '';
      }
    } else {
      filter = '';
    }
  } else {
    // all bc selected
    getAvalPoints = prepareBcLabelToRequest(pAllBc);
    if (getAvalPoints !== '') {
      filter = "AND Code in('', " + getAvalPoints + ')';
    } else {
      filter = 'no bc';
    }
  }

  // get aval points with data for table
  let getAvalPointsWithAttributes: any[] = [];
  if (filter !== '') {
    // delete Code filter object, because dropdownlist don't have value Code for resquest
    delete filters['Code'];
    getAvalPointsWithAttributes = await getEcpBc(
      filters,
      pContractCode,
      filter
    );
  }

  return {
    dataTable: getAvalPointsWithAttributes,
    filter: filter,
  };
};

// customize rendering for highlighting collection pool
export const highlightBc = (pBcName: string) => {
  return {
    type: 'unique-value',
    field: 'CollectionPoolCode',
    defaultSymbol: {
      type: 'simple-line',
      style: 'solid',
      color: [178, 178, 178, 255],
      width: 3,
    },
    uniqueValueInfos: [
      {
        symbol: {
          type: 'simple-line',
          style: 'solid',
          color: [168, 112, 0, 255],
          width: 3,
        },
        value: pBcName,
      },
    ],
  };
};

//get First And Last Day Of Year function
export function getFirstAndLastDayOfYear(year = new Date().getFullYear()) {  
  const firstDay = new Date(year, 0, 1);
  const lastDay = new Date(year, 11, 31);

  function formatDate(date) {
    const year = date.getFullYear().toString().padStart(4, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
  }
  
  return {
    firstDay: formatDate(firstDay),
    lastDay: formatDate(lastDay),
  };
}

// Get ECP table data with collection pool id
export function getEcpTableData(
  dataIdList: any[],
  dataTable: any[],
  showCollectionPoolsNotConfigured?: boolean,
  param?: string,
): any[] {
  let arr: any = [];
  //Get collectionPoolId where is available
  dataIdList.forEach((item) => {
    dataTable.forEach((data) => {
      if (data.Code === item.avalPoint) {
        arr.push({
          ...data,
          collectionPoolId: item.id,
          collectionPoolLabel: item.name,
          Commune: item.commune,
        });
      }
    });
  });
  let output = avoidDuplicate(arr, 'Code');

  let collectionPoolsNotConfigured: any[] = [];
  //Case where black categ is selected or all data selected
  if (showCollectionPoolsNotConfigured === true) {
    // get collection pool not configured
    dataIdList.forEach((data) => {
      if (data.avalPoint === null) {
        collectionPoolsNotConfigured.push({
          ...data,
          collectionPoolId: data.id,
          collectionPoolLabel: data.name,
          Commune: data.commune,
        });
      }
    });
    if (param === '') {
      // show only all collection pools not configured
      collectionPoolsNotConfigured.forEach((d) => {
        output.push({
          ...d,
          collectionPoolId: d.id,
          collectionPoolLabel: d.name,
          Commune: d.commune,
        });
      });
    } else {
      // show only selected collection pool configured or not
      const iSFound = collectionPoolsNotConfigured.find((c) => c.code === param);
      if (iSFound !== undefined) {
        output.push({
          ...iSFound,
          collectionPoolId: iSFound.id,
          collectionPoolLabel: iSFound.name,
          Commune: iSFound.commune,
        });
      }
    }
  }
  return output;
}

export const isBlackChecked = (pFilters: any) => {
  const { Color } = pFilters;
  let isBlackChecked = false;
  if (Color.code.includes('NOIR')) {
    isBlackChecked = true;
  } else if (Color.code === '') {
    isBlackChecked = true;
  }
  return isBlackChecked;
};

export const avoidDuplicate = (pArray: any[], pOutfield: string) => {
  return pArray.reduce((acc: any, obj) => {
    if (!acc.some((o: any) => o[pOutfield] === obj[pOutfield])) {
      acc.push(obj);
    }
    return acc;
  }, []);
};

export const linearRegressionThroughOrigin = (x: number[], y: number[]): { slope: number | null, r2: number | null } => {
  let slope: number | null = null;
  let r2: number | null = null;

  if (x.length === y.length && x.length > 0) {
    let sumXy = 0;
    let sumX2 = 0;
    let sumY2 = 0;

    // Compute the necessary sums for slope and R²
    x.forEach((xi, i) => {
      sumXy += xi * y[i];
      sumX2 += xi * xi;
      sumY2 += y[i] * y[i];
    });

    // Check if sumX2 is zero (to avoid division by zero in slope calculation)
    if (sumX2 === 0) {
      console.error('Sum of squares of x values is zero, cannot calculate slope');
      return { slope: null, r2: null };  // Return null values if division by zero occurs
    }

    // Calculate slope: sum(X * Y) / sum(X^2)
    slope = sumXy / sumX2;

    // Check if sumX2 or sumY2 are zero (to avoid division by zero in R² calculation)
    if (sumX2 === 0 || sumY2 === 0) {
      r2 = null;  // Return null for R² if there's an issue with the data
    } else {
      // Calculate R²: (sum(X * Y)^2) / (sum(X^2) * sum(Y^2))
      r2 = Math.pow(sumXy, 2) / (sumX2 * sumY2);
    }
  } else {
    console.log('Les tableaux x et y doivent avoir la même longueur');
  }

  return { slope, r2 };
};